import React from 'react';

import { HeaderBar } from '../../../../../shared/components/header-components/HeaderBar/HeaderBar';
import { SOLUTION_TYPE } from '../../../../../shared/constants/user-info/solutionType';
import { HeaderLogo } from '../../../../../shared/components/header-components/HeaderLogo/HeaderLogo';

const ScanIqHeader = () => {
  return (
    <HeaderBar toolbarComponent="div" inAngularContainer solution={SOLUTION_TYPE.SCAN_IQ}>
      <HeaderLogo solution={SOLUTION_TYPE.SCAN_IQ} />
    </HeaderBar>
  );
};

export { ScanIqHeader };
